var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":null,"table":_vm.table,"default_limit":'1000',"addbutton":false,"default_sort":'created_at',"default_sort_typ":'DESC',"extension":_vm.extension,"export_csv":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }